/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CampaignProgressResponse,
  EscalationAcknowledgeRequest,
  EscalationRequest,
  EscalationResponse,
  EscalationStatusResponse,
  MassEmailCampaignRequest,
  MassEmailCampaignResponse,
  NotifyRequest,
  NotifyResponse,
  SingleNotificationRequest,
  SingleNotificationResponse,
} from '../models/index';
import {
    CampaignProgressResponseFromJSON,
    CampaignProgressResponseToJSON,
    EscalationAcknowledgeRequestFromJSON,
    EscalationAcknowledgeRequestToJSON,
    EscalationRequestFromJSON,
    EscalationRequestToJSON,
    EscalationResponseFromJSON,
    EscalationResponseToJSON,
    EscalationStatusResponseFromJSON,
    EscalationStatusResponseToJSON,
    MassEmailCampaignRequestFromJSON,
    MassEmailCampaignRequestToJSON,
    MassEmailCampaignResponseFromJSON,
    MassEmailCampaignResponseToJSON,
    NotifyRequestFromJSON,
    NotifyRequestToJSON,
    NotifyResponseFromJSON,
    NotifyResponseToJSON,
    SingleNotificationRequestFromJSON,
    SingleNotificationRequestToJSON,
    SingleNotificationResponseFromJSON,
    SingleNotificationResponseToJSON,
} from '../models/index';

export interface AcknowledgeEscalationRequest {
    workflowId: string;
    escalationAcknowledgeRequest: EscalationAcknowledgeRequest;
    sessionId?: string;
}

export interface CancelCampaignRequest {
    workflowId: string;
}

export interface EscalateNowRequest {
    workflowId: string;
}

export interface GetCampaignProgressRequest {
    workflowId: string;
}

export interface GetEscalationStatusRequest {
    workflowId: string;
}

export interface NotifyOperationRequest {
    notifyRequest: NotifyRequest;
    sessionId?: string;
}

export interface PauseCampaignRequest {
    workflowId: string;
}

export interface ResumeCampaignRequest {
    workflowId: string;
}

export interface SendNotificationRequest {
    singleNotificationRequest: SingleNotificationRequest;
    sessionId?: string;
}

export interface StartCampaignRequest {
    massEmailCampaignRequest: MassEmailCampaignRequest;
    sessionId?: string;
}

export interface StartEscalationRequest {
    escalationRequest: EscalationRequest;
    sessionId?: string;
}

/**
 * NotificationsApi - interface
 * 
 * @export
 * @interface NotificationsApiInterface
 */
export interface NotificationsApiInterface {
    /**
     * Send ACKNOWLEDGED signal to escalation workflow. Records acknowledgedBy and escalationTimestamp in audit trail.
     * @summary Acknowledge escalation
     * @param {string} workflowId 
     * @param {EscalationAcknowledgeRequest} escalationAcknowledgeRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    acknowledgeEscalationRaw(requestParameters: AcknowledgeEscalationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Send ACKNOWLEDGED signal to escalation workflow. Records acknowledgedBy and escalationTimestamp in audit trail.
     * Acknowledge escalation
     */
    acknowledgeEscalation(requestParameters: AcknowledgeEscalationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Send CANCEL signal to campaign workflow
     * @summary Cancel campaign
     * @param {string} workflowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    cancelCampaignRaw(requestParameters: CancelCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Send CANCEL signal to campaign workflow
     * Cancel campaign
     */
    cancelCampaign(requestParameters: CancelCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Send ESCALATE_NOW signal to skip timeout and escalate immediately
     * @summary Escalate now
     * @param {string} workflowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    escalateNowRaw(requestParameters: EscalateNowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Send ESCALATE_NOW signal to skip timeout and escalate immediately
     * Escalate now
     */
    escalateNow(requestParameters: EscalateNowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Query campaign progress (sent, total, status)
     * @summary Get campaign progress
     * @param {string} workflowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    getCampaignProgressRaw(requestParameters: GetCampaignProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignProgressResponse>>;

    /**
     * Query campaign progress (sent, total, status)
     * Get campaign progress
     */
    getCampaignProgress(requestParameters: GetCampaignProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignProgressResponse>;

    /**
     * Query escalation status (current tier, total tiers, acknowledgedBy)
     * @summary Get escalation status
     * @param {string} workflowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    getEscalationStatusRaw(requestParameters: GetEscalationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EscalationStatusResponse>>;

    /**
     * Query escalation status (current tier, total tiers, acknowledgedBy)
     * Get escalation status
     */
    getEscalationStatus(requestParameters: GetEscalationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EscalationStatusResponse>;

    /**
     * Send notifications by intent (category, recipients, content). Channel and delivery resolved by orchestration (preferences, profile, integrations). Supports EMAIL/SMS today; Slack/Teams when integrations added.
     * @summary Send intent-based notification
     * @param {NotifyRequest} notifyRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    notifyRaw(requestParameters: NotifyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotifyResponse>>;

    /**
     * Send notifications by intent (category, recipients, content). Channel and delivery resolved by orchestration (preferences, profile, integrations). Supports EMAIL/SMS today; Slack/Teams when integrations added.
     * Send intent-based notification
     */
    notify(requestParameters: NotifyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotifyResponse>;

    /**
     * Send PAUSE signal to campaign workflow
     * @summary Pause campaign
     * @param {string} workflowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    pauseCampaignRaw(requestParameters: PauseCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Send PAUSE signal to campaign workflow
     * Pause campaign
     */
    pauseCampaign(requestParameters: PauseCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Send RESUME signal to campaign workflow
     * @summary Resume campaign
     * @param {string} workflowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    resumeCampaignRaw(requestParameters: ResumeCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Send RESUME signal to campaign workflow
     * Resume campaign
     */
    resumeCampaign(requestParameters: ResumeCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Send a single email or SMS via Azure Communication Services. Resolves ACS instance for tenant (tenant instance first, then platform default).
     * @summary Send single notification
     * @param {SingleNotificationRequest} singleNotificationRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    sendNotificationRaw(requestParameters: SendNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleNotificationResponse>>;

    /**
     * Send a single email or SMS via Azure Communication Services. Resolves ACS instance for tenant (tenant instance first, then platform default).
     * Send single notification
     */
    sendNotification(requestParameters: SendNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleNotificationResponse>;

    /**
     * Start a mass email campaign via ACS. Returns workflowId for progress queries and signals (pause/resume/cancel).
     * @summary Start mass email campaign
     * @param {MassEmailCampaignRequest} massEmailCampaignRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    startCampaignRaw(requestParameters: StartCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MassEmailCampaignResponse>>;

    /**
     * Start a mass email campaign via ACS. Returns workflowId for progress queries and signals (pause/resume/cancel).
     * Start mass email campaign
     */
    startCampaign(requestParameters: StartCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MassEmailCampaignResponse>;

    /**
     * Start an escalation workflow. Notifies tier 1, awaits ACKNOWLEDGED or timeout, then escalates to next tier. Returns workflowId for status queries and signals.
     * @summary Start escalation workflow
     * @param {EscalationRequest} escalationRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    startEscalationRaw(requestParameters: StartEscalationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EscalationResponse>>;

    /**
     * Start an escalation workflow. Notifies tier 1, awaits ACKNOWLEDGED or timeout, then escalates to next tier. Returns workflowId for status queries and signals.
     * Start escalation workflow
     */
    startEscalation(requestParameters: StartEscalationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EscalationResponse>;

}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI implements NotificationsApiInterface {

    /**
     * Send ACKNOWLEDGED signal to escalation workflow. Records acknowledgedBy and escalationTimestamp in audit trail.
     * Acknowledge escalation
     */
    async acknowledgeEscalationRaw(requestParameters: AcknowledgeEscalationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling acknowledgeEscalation().'
            );
        }

        if (requestParameters['escalationAcknowledgeRequest'] == null) {
            throw new runtime.RequiredError(
                'escalationAcknowledgeRequest',
                'Required parameter "escalationAcknowledgeRequest" was null or undefined when calling acknowledgeEscalation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/notifications/escalations/{workflowId}/acknowledge`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EscalationAcknowledgeRequestToJSON(requestParameters['escalationAcknowledgeRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send ACKNOWLEDGED signal to escalation workflow. Records acknowledgedBy and escalationTimestamp in audit trail.
     * Acknowledge escalation
     */
    async acknowledgeEscalation(requestParameters: AcknowledgeEscalationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeEscalationRaw(requestParameters, initOverrides);
    }

    /**
     * Send CANCEL signal to campaign workflow
     * Cancel campaign
     */
    async cancelCampaignRaw(requestParameters: CancelCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling cancelCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/notifications/campaigns/{workflowId}/cancel`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send CANCEL signal to campaign workflow
     * Cancel campaign
     */
    async cancelCampaign(requestParameters: CancelCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelCampaignRaw(requestParameters, initOverrides);
    }

    /**
     * Send ESCALATE_NOW signal to skip timeout and escalate immediately
     * Escalate now
     */
    async escalateNowRaw(requestParameters: EscalateNowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling escalateNow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/notifications/escalations/{workflowId}/escalate-now`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send ESCALATE_NOW signal to skip timeout and escalate immediately
     * Escalate now
     */
    async escalateNow(requestParameters: EscalateNowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.escalateNowRaw(requestParameters, initOverrides);
    }

    /**
     * Query campaign progress (sent, total, status)
     * Get campaign progress
     */
    async getCampaignProgressRaw(requestParameters: GetCampaignProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignProgressResponse>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling getCampaignProgress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/notifications/campaigns/{workflowId}/progress`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignProgressResponseFromJSON(jsonValue));
    }

    /**
     * Query campaign progress (sent, total, status)
     * Get campaign progress
     */
    async getCampaignProgress(requestParameters: GetCampaignProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignProgressResponse> {
        const response = await this.getCampaignProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Query escalation status (current tier, total tiers, acknowledgedBy)
     * Get escalation status
     */
    async getEscalationStatusRaw(requestParameters: GetEscalationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EscalationStatusResponse>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling getEscalationStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/notifications/escalations/{workflowId}/status`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EscalationStatusResponseFromJSON(jsonValue));
    }

    /**
     * Query escalation status (current tier, total tiers, acknowledgedBy)
     * Get escalation status
     */
    async getEscalationStatus(requestParameters: GetEscalationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EscalationStatusResponse> {
        const response = await this.getEscalationStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send notifications by intent (category, recipients, content). Channel and delivery resolved by orchestration (preferences, profile, integrations). Supports EMAIL/SMS today; Slack/Teams when integrations added.
     * Send intent-based notification
     */
    async notifyRaw(requestParameters: NotifyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotifyResponse>> {
        if (requestParameters['notifyRequest'] == null) {
            throw new runtime.RequiredError(
                'notifyRequest',
                'Required parameter "notifyRequest" was null or undefined when calling notify().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/notifications/notify`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotifyRequestToJSON(requestParameters['notifyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotifyResponseFromJSON(jsonValue));
    }

    /**
     * Send notifications by intent (category, recipients, content). Channel and delivery resolved by orchestration (preferences, profile, integrations). Supports EMAIL/SMS today; Slack/Teams when integrations added.
     * Send intent-based notification
     */
    async notify(requestParameters: NotifyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotifyResponse> {
        const response = await this.notifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send PAUSE signal to campaign workflow
     * Pause campaign
     */
    async pauseCampaignRaw(requestParameters: PauseCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling pauseCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/notifications/campaigns/{workflowId}/pause`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send PAUSE signal to campaign workflow
     * Pause campaign
     */
    async pauseCampaign(requestParameters: PauseCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.pauseCampaignRaw(requestParameters, initOverrides);
    }

    /**
     * Send RESUME signal to campaign workflow
     * Resume campaign
     */
    async resumeCampaignRaw(requestParameters: ResumeCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling resumeCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/notifications/campaigns/{workflowId}/resume`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send RESUME signal to campaign workflow
     * Resume campaign
     */
    async resumeCampaign(requestParameters: ResumeCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resumeCampaignRaw(requestParameters, initOverrides);
    }

    /**
     * Send a single email or SMS via Azure Communication Services. Resolves ACS instance for tenant (tenant instance first, then platform default).
     * Send single notification
     */
    async sendNotificationRaw(requestParameters: SendNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleNotificationResponse>> {
        if (requestParameters['singleNotificationRequest'] == null) {
            throw new runtime.RequiredError(
                'singleNotificationRequest',
                'Required parameter "singleNotificationRequest" was null or undefined when calling sendNotification().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/notifications/send`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SingleNotificationRequestToJSON(requestParameters['singleNotificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SingleNotificationResponseFromJSON(jsonValue));
    }

    /**
     * Send a single email or SMS via Azure Communication Services. Resolves ACS instance for tenant (tenant instance first, then platform default).
     * Send single notification
     */
    async sendNotification(requestParameters: SendNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleNotificationResponse> {
        const response = await this.sendNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start a mass email campaign via ACS. Returns workflowId for progress queries and signals (pause/resume/cancel).
     * Start mass email campaign
     */
    async startCampaignRaw(requestParameters: StartCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MassEmailCampaignResponse>> {
        if (requestParameters['massEmailCampaignRequest'] == null) {
            throw new runtime.RequiredError(
                'massEmailCampaignRequest',
                'Required parameter "massEmailCampaignRequest" was null or undefined when calling startCampaign().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/notifications/campaigns`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MassEmailCampaignRequestToJSON(requestParameters['massEmailCampaignRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MassEmailCampaignResponseFromJSON(jsonValue));
    }

    /**
     * Start a mass email campaign via ACS. Returns workflowId for progress queries and signals (pause/resume/cancel).
     * Start mass email campaign
     */
    async startCampaign(requestParameters: StartCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MassEmailCampaignResponse> {
        const response = await this.startCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start an escalation workflow. Notifies tier 1, awaits ACKNOWLEDGED or timeout, then escalates to next tier. Returns workflowId for status queries and signals.
     * Start escalation workflow
     */
    async startEscalationRaw(requestParameters: StartEscalationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EscalationResponse>> {
        if (requestParameters['escalationRequest'] == null) {
            throw new runtime.RequiredError(
                'escalationRequest',
                'Required parameter "escalationRequest" was null or undefined when calling startEscalation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/notifications/escalations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EscalationRequestToJSON(requestParameters['escalationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EscalationResponseFromJSON(jsonValue));
    }

    /**
     * Start an escalation workflow. Notifies tier 1, awaits ACKNOWLEDGED or timeout, then escalates to next tier. Returns workflowId for status queries and signals.
     * Start escalation workflow
     */
    async startEscalation(requestParameters: StartEscalationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EscalationResponse> {
        const response = await this.startEscalationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
